
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { StudentService } from 'src/app/_services/student.service';
import { SyllabusService } from 'src/app/_services/syllabus.service';
import Swal from 'sweetalert2';

declare var window: any;

@Component({
  selector: 'app-worksheet',
  templateUrl: './worksheet.component.html',
  styleUrls: ['./worksheet.component.css']
})
export class WorksheetComponent implements OnInit {
  syllabusinfo=undefined

  subTopicIdList=[]
  subTopicNameList=[]
  server_subject_id=0
  imageSource:any
  loading=false
  emailModal=undefined
  constructor(private activeRoute:ActivatedRoute, private syllabusService:SyllabusService,private studentService:StudentService,private router:Router) { }

  ngOnInit(): void {
    this.activeRoute.params.subscribe(
      myParams=>{
        this.server_subject_id=myParams['server_subject_id']
        this.syllabusService.levelSyllabusDetail(this.server_subject_id).subscribe({
          next:(data:ResultData)=>{
            this.syllabusinfo=data.rs.data

          }

        }

        )

      }
    )

  }

  updateSubTopics(mySubTopicEvent:any){
    let id =mySubTopicEvent.id
    let name=mySubTopicEvent.name
     if(this.subTopicIdList.includes(id)){
      const index = this.subTopicIdList.indexOf(id);
        if (index > -1) {
            this.subTopicIdList.splice(index, 1);
            this.subTopicNameList.splice(index, 1);
        }
     }else{
      this.subTopicIdList.push(id)
      this.subTopicNameList.push(name)
     }

  }

  removeItem(index){
    if (index > -1) {
      this.subTopicIdList.splice(index, 1);
      this.subTopicNameList.splice(index, 1);
  }
  }

  openEmailForm(){
    this.emailModal = new window.bootstrap.Modal(
      document.getElementById('myEmailModal')
    );
    this.emailModal.show()
  }
  validEmailSubmission(email:string){
        this.generateOpenPdf(email)
  }
  generateOpenPdf(email:string){
    this.loading=true

    this.studentService.createFreeQuiz(this.server_subject_id,this.formatData(email)).subscribe(
      {next:(data:ResultData)=>{
        this.loading=false
        this.alertEmailSent(email)
        this.subTopicIdList=[]
        this.subTopicNameList=[]
        this.router.navigate(['/'])
      }
    }
      )
  }




  alertNoSelectionMade(){
    Swal.fire("Oops","We do no see any topic selected. Please select at least one subtopic for the worksheet",'info')
  }

  alertEmailSent(mail:string){
    Swal.fire("Yes","We have sent the download link. Please check your email at "+mail,'info')
  }

  formatData(email:string){
    let data = new URLSearchParams();
    data.set('id', this.server_subject_id.toString());
    data.set('email', email);
    data.set('sCount', this.subTopicIdList.length.toString());
    for(let i=0; i < this.subTopicIdList.length;i++){
      data.append('subTopics', this.subTopicIdList[i].toString());
    }
    return data.toString()
  }
  closeModal(){
    this.emailModal.hide()
  }
}

